import { BaseComponent } from '../_core/components/base.component';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getExternalUrl, externalUrlQueryStringParam, isAllowedExternalUrl } from '../_core/url.utils';

import { Location } from '@angular/common';

declare const environmentResource: any;

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    standalone: false
})
export class RedirectComponent extends BaseComponent {
    private static readonly delayMilliseconds = 3000;

    public externalUrl: string;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly location: Location) {
        super();

        this.externalUrl = getExternalUrl(this.route) || this._getExternalUrl();

        // Only our own sites; anything else shows "No redirect found" with a link home.
        if (String.isNullOrEmpty(this.externalUrl) || !isAllowedExternalUrl(this.externalUrl)) {
            this.externalUrl = null;
        }

        // Our own Report Center is where most users land here from, straight after signing in, so there is
        // nothing to read on the way. Anywhere else keeps the pause, so the destination is visible first.
        setTimeout(() => {
            this._doRedirect();
        }, this._isReportCenter(this.externalUrl) ? 0 : RedirectComponent.delayMilliseconds);
    }

    private _isReportCenter(url: string): boolean {
        try {
            const reportCenterUri = environmentResource?.reportCenter?.baseUri;
            return !!url && !!reportCenterUri
                && new URL(url, window.location.href).origin === new URL(reportCenterUri, window.location.href).origin;
        } catch {
            return false;
        }
    }

    private _doRedirect(): void {
        if (!String.isNullOrEmpty(this.externalUrl)) {
            location.replace(this.externalUrl);
        }
    }

    private _getExternalUrl(): string {
        const url = this.location.path() || '';
        const searchString = `${externalUrlQueryStringParam}=`;
        const index = url.indexOf(searchString);

        let output: string;

        if (index >= 0) {
            output = url.substring(index + searchString.length);
        }

        if (String.isNullOrEmpty(output)) {
            return null;
        }

        return decodeURIComponent(output);
    }
}
